const r = {
  "primary-brand": "white",
  "primary-gray": "white",
  "primary-ghost": "brand",
  "secondary-blue": "brand",
  "secondary-gray": "secondary",
  text: "brand",
  "text-gray": "secondary"
};
export {
  r as VARIANT_TO_SPINNER
};
//# sourceMappingURL=index.es2476.js.map
